import { render, staticRenderFns } from "./AccommodationServicesCard.vue?vue&type=template&id=09887af4&"
import script from "./AccommodationServicesCard.vue?vue&type=script&lang=js&"
export * from "./AccommodationServicesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports